<template>
  <div
    class="relative-position self-center chosen-color flex-center flex"
    :class="divClasses"
    :style="divStyles"
  >
    <span v-if="!dense" class="color-text">{{ textToDisplay }}</span>

    <div
      v-if="showIcon || innerLabel"
      class="flex no-wrap items-center q-mx-auto"
      :class="{'q-gutter-xs': showIcon && innerLabel}"
    >
      <q-icon
        v-if="showIcon"
        :name="icon || (!value ? 'mdi-invert-colors-off' : 'mdi-auto-fix')"
        :class="{'q-pl-sm': !dense}"
        size="1.5em"
      />

      <q-item-label
        v-if="innerLabel"
        class="inner-label-text"
      >
        {{ innerLabel }}
      </q-item-label>
    </div>

    <slot />
  </div>
</template>

<script>
/**
 * Uses default QColor but adds it as a popover element
 */
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String
    },
    innerLabel: {
      type: String
    },
    dense: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    dynamicColors: {
      type: Object,
      default: null,
      validator: (value) => {
        return !!value && typeof value === 'object'
      }
    }
  },
  computed: {
    showIcon () {
      return this.icon || this.isTransparent || (this.hasDynamicValue && this.dense)
    },
    isTransparent () {
      return !this.value || this.value === 'transparent'
    },
    hasDynamicValue () {
      return ['primary', 'accent'].includes(this.value)
    },
    colorToDisplay () {
      if (this.hasDynamicValue) {
        return this.dynamicColors[this.value]
      }
      else if (this.isTransparent) {
        return '#fff'
      }
      return this.value
    },
    textToDisplay () {
      switch (true) {
        case this.value === 'primary': return 'Dynamic Primary Colour'
        case this.value === 'accent': return 'Dynamic Accent Colour'
        case this.isTransparent: return 'No Colour'
        default: return this.value.toUpperCase()
      }
    },
    divClasses () {
      return {
        'no-color': this.isTransparent,
        'q-mt-sm': !!this.label,
        'flex justify-end items-center q-pa-sm': !this.dense,
        'text-white': this.checkBrightnessOfHex(this.colorToDisplay) <= 170,
        'text-black': this.checkBrightnessOfHex(this.colorToDisplay) > 170,
        'dense': this.dense,
        'shadow-2': this.shadow,
        ['dynamic-' + this.value]: this.hasDynamicValue
      }
    },
    divStyles () {
      const width = this.width || (this.dense ? '25px' : '150px')
      return {
        'background-color': this.colorToDisplay,
        width,
        'height': this.height ? `${this.height} !important` : undefined
      }
    }
  }
}
</script>

<style scoped lang="scss">
.chosen-color {
  border-radius: 4px;
  height: 40px;

  &.dense {
    height: 25px;
  }

  .color-text {
    font-size: 0.9em;
    line-height: 1em;
  }

  .inner-label-text {
    font-size: 0.69em;
    line-height: 1.1em !important;
  }
}
</style>
